import SalesBusinessReportTable from "./SalesBusinessReportTable";
import SalesReportTable from "./SalesReportTable";
import GlossaryReportCVM from "../GlossaryReportCVM"
import { useCentralStore } from "../../../store/appContext"

const SalesReportData = ({ salesReportData }) => {
    const [{ selectedTab}, dispatch] = useCentralStore()
    let _salesTrainingReport = salesReportData?.salesTrainingReport
    
    let _salesBusinessChurnClosingReport = salesReportData?.salesBusinessChurnClosingReport || []
    let _salesBusinessReport = salesReportData?.salesBusinessReport || []
    let _reportData = [..._salesBusinessReport, ..._salesBusinessChurnClosingReport]

    return(
        <div className="flex flex-col text-black">
            <div className="flex flex-col text-black w-full mx-auto">
                <p className="font-bold my-0 py-0">Sales Business Report</p>
                {selectedTab === 'Glossary' ?<GlossaryReportCVM/>
                : <SalesBusinessReportTable salesReportData={_reportData} />}
            </div>
            { selectedTab === 'Glossary' ? "" :_salesTrainingReport?.length > 0 &&
                <div className="flex flex-col text-black w-full mx-auto">
                    <p className="font-bold my-0 py-0">Sales Training</p>
                    <SalesReportTable salesReportData={_salesTrainingReport} />
                </div>
            }
        </div>
    )
}

export default SalesReportData